<template>
  <div class="qq-list page-box">
    <div class="page-content">
      <el-row :gutter="12" class="content-header">
        <el-col :lg="4" :md="8" :sm="12" :xs="24">
          <el-input
            v-model="filters.name"
            placeholder="机器人名称"
            clearable
            @keyup.enter.native="searchHandle"
          ></el-input>
        </el-col>
        <el-col :lg="4" :md="8" :sm="12" :xs="24">
          <el-input
            v-model="filters.qqNumber"
            placeholder="QQ号"
            clearable
            @keyup.enter.native="searchHandle"
          ></el-input>
        </el-col>
        <el-col :lg="4" :md="8" :sm="12" :xs="24">
          <el-select
            v-model="filters.status"
            placeholder="状态"
            style="width: 100%"
            clearable
            @change="searchHandle"
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-col>
        <el-col :lg="8" :md="16" :sm="24" :xs="24" class="button-group">
          <vs-button class="btn" type="info" @click="searchHandle">查询</vs-button>
          <vs-button
            v-if="isAuth('wx:qqBotConfig:save')"
            class="btn add-btn"
            @click="addHandle"
          >新增</vs-button>
          <vs-button
            v-if="isAuth('wx:qqBotConfig:delete')"
            :disabled="selected.length < 1"
            class="mutil-btn"
            @click="deleteHandle()"
          >批量删除</vs-button>
        </el-col>
      </el-row>

      <div class="vs-table-outer">
        <vs-table multiple v-model="selected" :data="listData">
          <template slot="thead">
            <vs-th>ID</vs-th>
            <vs-th>机器人名称</vs-th>
            <vs-th>描述</vs-th>
            <vs-th>OneBot地址</vs-th>
            <vs-th>QQ号</vs-th>
            <vs-th>昵称</vs-th>
            <vs-th>状态</vs-th>
            <vs-th>创建时间</vs-th>
            <vs-th>更新时间</vs-th>
            <vs-th>操作</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="tr in data"
              :key="tr.id"
              :data="tr"
            >
              <vs-td>{{tr.id}}</vs-td>
              <vs-td>{{tr.name || '-'}}</vs-td>
              <vs-td>{{tr.desc || '-'}}</vs-td>
              <vs-td class="base-url-cell">{{tr.baseUrl || '-'}}</vs-td>
              <vs-td>{{tr.qqNumber || '-'}}</vs-td>
              <vs-td>{{tr.nickname || '-'}}</vs-td>
              <vs-td>
                <span class="self-tag" :style="getStyle(tr)">
                  {{tr.status === 1 ? '启用' : '禁用'}}
                </span>
              </vs-td>
              <vs-td>{{tr.createTime ? parseTime(tr.createTime) : '-'}}</vs-td>
              <vs-td>{{tr.updateTime ? parseTime(tr.updateTime) : '-'}}</vs-td>
              <vs-td class="operation-cell">
                <el-button
                  type="text"
                  @click.stop="checkConnection(tr.id)"
                >检查连接</el-button>
                <el-button
                  v-if="isAuth('wx:qqBotConfig:update')"
                  type="text"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  v-if="isAuth('wx:qqBotConfig:delete')"
                  type="text"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr.id)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div v-if="total" class="pagination-outer">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          v-model="page"
          class="pagination-box"
          :max="max"
          :total="pageSize"
        ></vs-pagination>
      </div>
    </div>

    <sliderBarDialogShell
      class="qq-config-dialog"
      :click-not-close="true"
      :dialog-show="dialogShow"
      :dialog-title="editing ? '编辑QQ推送渠道' : '新增QQ推送渠道'"
      @close="closeDialog"
      @submit="submitHandle"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        :label-position="labelPosition"
        label-width="110px"
      >
        <el-form-item label="机器人名称" prop="name">
          <el-input
            v-model="form.name"
            maxlength="40"
            show-word-limit
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input
            v-model="form.desc"
            type="textarea"
            maxlength="100"
            show-word-limit
            :rows="3"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="OneBot地址" prop="baseUrl">
          <el-input
            v-model="form.baseUrl"
            maxlength="255"
            placeholder="例如：http://127.0.0.1:3000"
          ></el-input>
        </el-form-item>
        <el-form-item label="Access Token" prop="accessToken">
          <el-input
            v-model="form.accessToken"
            type="password"
            maxlength="255"
            show-password
            autocomplete="new-password"
            :placeholder="editing ? '留空则保留原 Token' : '请输入'"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </sliderBarDialogShell>

    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import formLabalPosition from '@/mixins/formLabalPosition'
import initData from '@/mixins/initData'
import multipleDeleteDialog from '@/components/public/multipleDeleteDialog'
import { colorRgba, parseTime } from '@/utils'
import {
  buildQqConfigPayload,
  checkQqConnection,
  deleteQqConfig,
  editQqConfig,
  hasQqTokenControlCharacter,
  isValidQqBaseUrl,
  saveQqConfig
} from '@/api/sys/robitConfig/qq'

function emptyForm() {
  return {
    id: null,
    name: '',
    desc: '',
    baseUrl: '',
    accessToken: '',
    status: 1
  }
}

export default {
  name: 'qqList',
  components: {
    multipleDeleteDialog
  },
  mixins: [initData, formLabalPosition],
  data() {
    return {
      selected: [],
      ids: [],
      dialogShow: false,
      editing: false,
      form: emptyForm(),
      filters: {
        name: '',
        qqNumber: '',
        status: ''
      },
      red: '#D85E5F',
      green: '#41B883',
      rules: {
        name: [
          { required: true, whitespace: true, message: '请输入机器人名称', trigger: 'blur' },
          { max: 40, message: '机器人名称不能超过40个字符', trigger: 'blur' }
        ],
        desc: [
          { required: true, whitespace: true, message: '请输入描述', trigger: 'blur' },
          { max: 100, message: '描述不能超过100个字符', trigger: 'blur' }
        ],
        baseUrl: [
          { required: true, whitespace: true, message: '请输入OneBot地址', trigger: 'blur' },
          { max: 255, message: 'OneBot地址不能超过255个字符', trigger: 'blur' },
          { validator: this.validateBaseUrl, trigger: 'blur' }
        ],
        accessToken: [
          { validator: this.validateAccessToken, trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.$nextTick(() => this.init())
  },
  methods: {
    parseTime,
    beforeInit() {
      this.url = '/wx/manage/qqBotConfig/list'
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order: 'desc'
      }
      if (this.filters.name) this.params.name = this.filters.name
      if (this.filters.qqNumber) this.params.qqNumber = this.filters.qqNumber
      if (this.filters.status !== '') this.params.status = this.filters.status
      return true
    },
    validateBaseUrl(rule, value, callback) {
      if (!value || isValidQqBaseUrl(value)) {
        callback()
      } else {
        callback(new Error('请输入不含账号、查询参数或片段的HTTP(S)地址'))
      }
    },
    validateAccessToken(rule, value, callback) {
      const token = String(value || '')
      if (!token.trim()) {
        callback(this.editing ? undefined : new Error('请输入Access Token'))
      } else if (token.length > 255) {
        callback(new Error('Access Token不能超过255个字符'))
      } else if (hasQqTokenControlCharacter(token)) {
        callback(new Error('Access Token不能包含控制字符'))
      } else {
        callback()
      }
    },
    searchHandle() {
      this.page = 1
      this.init()
    },
    addHandle() {
      this.editing = false
      this.form = emptyForm()
      this.dialogShow = true
      this.clearValidate()
    },
    editHandle(row) {
      this.editing = true
      this.form = {
        id: row.id,
        name: row.name || '',
        desc: row.desc || '',
        baseUrl: row.baseUrl || '',
        accessToken: '',
        status: row.status
      }
      this.dialogShow = true
      this.clearValidate()
    },
    closeDialog() {
      this.dialogShow = false
      this.clearValidate()
    },
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    submitHandle() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const action = this.editing ? editQqConfig : saveQqConfig
        action(buildQqConfigPayload(this.form, this.editing)).then(res => {
          if (!res || res.code !== 200) return
          this.$message({
            type: 'success',
            message: this.editing ? '编辑成功' : '添加成功'
          })
          this.dialogShow = false
          this.searchHandle()
        })
      })
    },
    checkConnection(id) {
      checkQqConnection(id).then(res => {
        if (!res || res.code !== 200) return
        this.$message({
          type: 'success',
          message: `连接成功：${res.nickname || '-'}（${res.qqNumber || '-'}）`
        })
        this.init()
      })
    },
    deleteHandle(id) {
      this.ids = id ? [id] : this.selected.map(item => item.id)
      this.$refs.muldelete.dialogShow = true
    },
    confirmDelete(ids) {
      deleteQqConfig(ids).then(res => {
        if (!res || res.code !== 200) return
        this.$refs.muldelete.dialogShow = false
        this.$message({ type: 'success', message: '删除成功!' })
        this.searchHandle()
      })
    },
    getStyle(row) {
      const color = row.status === 1 ? this.green : this.red
      return {
        backgroundColor: colorRgba(color, 0.1),
        color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qq-list {
  .content-header .el-col {
    margin-bottom: 10px;
  }
  .button-group {
    display: flex;
    align-items: center;
  }
  .btn {
    margin-right: 10px;
  }
  .base-url-cell {
    max-width: 260px;
    word-break: break-all;
  }
  .operation-cell {
    white-space: nowrap;
  }
}
</style>

<style lang="scss">
@media screen and (min-width: 768px) {
  .qq-config-dialog.sidebar-dialog .vs-sidebar {
    width: 650px;
  }
}
</style>
